import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayTimeHour extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayTimeHour {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayTimeHour;

  public mode() {
    return TEDParseDateTimeMode.pdmH;
  }
}

export { TEDDisplayTimeHour };
